import { useSelector } from 'react-redux'
import Table from '../../atoms/display/Table'
import TableRow from '../../atoms/display/TableRow'
import TableCell from '../../atoms/display/TableCell'
import Label from '../../atoms/display/Label'
import useRouter from '../../../hooks/useRouter'
import { Agreement } from '../../../types/agreement'
import { SessionSelectors } from '../../../store/session/selectors'
import useDay from '../../../hooks/useDay'
import { FlexColumn, FlexRow } from '../../atoms/layout/Flex'
import Avatar from '../../atoms/display/Avatar'
import useAgreements from '../../../hooks/useAgreements'

type Props = {
  agreements: Agreement[]
  status: string
}

function DateTimeLabel({ value }: { value?: string | null }) {
  const { formatDateTime } = useDay()

  if (value) {
    return <Label text={formatDateTime(value)} />
  }
  return <Label text="-" />
}

function NextAgreementFlowView(props: { agreement: Agreement }) {
  const agreements = useAgreements({ fetch: false })
  const { agreement } = props
  const currentFlow = agreements.findCurrentFlow(agreement)
  if (currentFlow === null) {
    return null
  }

  return (
    <FlexRow align="center">
      <Avatar alt={currentFlow.user.name} url={currentFlow.user.icon} size="sm" />
      <Label text={currentFlow.user.name} />
    </FlexRow>
  )
}

export default function AgreementTable({ agreements, status }: Props) {
  const { agreementDetail } = useRouter()
  const companyId = useSelector(SessionSelectors.companyId)

  return (
    <Table
      header={
        <TableRow>
          <TableCell header size="sm3">
            <Label text="取引先企業名" />
          </TableCell>
          <TableCell header>
            <Label text="件名" />
          </TableCell>
          <TableCell header size="xs" align="center">
            <Label text="自社確認日時" />
          </TableCell>
          <TableCell header size="xs" align="center">
            <Label text="取引先確認日時" />
          </TableCell>
          <TableCell header size="xs" align="center">
            <Label text="ステータス" />
          </TableCell>
        </TableRow>
      }
    >
      {agreements.map((agreement) => (
        <TableRow key={agreement.id} onClick={() => agreementDetail(agreement.id)}>
          <TableCell size="sm3">
            <Label
              text={
                agreement.companies.find((agreementCompany) => agreementCompany.company?.id !== companyId)?.company
                  .name ?? '-'
              }
            />
          </TableCell>
          <TableCell>
            <Label text={agreement.name} />
          </TableCell>
          <TableCell size="xs" align="center">
            <DateTimeLabel
              value={
                agreement.companies.find((agreementCompany) => agreementCompany.company?.id === companyId)?.confirmedAt
              }
            />
          </TableCell>
          <TableCell size="xs" align="center">
            <DateTimeLabel
              value={
                agreement.companies.find((agreementCompany) => agreementCompany.company?.id !== companyId)?.confirmedAt
              }
            />
          </TableCell>
          <TableCell size="xs">
            <FlexColumn align="center">
              <Label text={status} />
              {companyId && <NextAgreementFlowView agreement={agreement} />}
            </FlexColumn>
          </TableCell>
        </TableRow>
      ))}
    </Table>
  )
}
